import { api as http } from '~/api/services'

export const getInvestorQualification = (companyId) =>
  http.get(`/companies/investorstatus/${companyId}`)
